export default __webpack_public_path__ + "a55df7d0a5070b031bd3a75c5edb236b.png";